const GA_ID = 'G-6QTXPTEV7F';

// Guards against running when the gtag script failed to load (ad blockers, dev).
const gtag = (...args) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag(...args);
  }
};

export const trackPageView = (path, title) => {
  gtag('event', 'page_view', {
    page_path: path,
    page_title: title || document.title,
    page_location: window.location.href,
    send_to: GA_ID,
  });
};

// Fire from any tool page when a user kicks off a generation.
// Example: trackToolUsed('profile_picture', { status: 'success' })
export const trackToolUsed = (tool, params = {}) => {
  gtag('event', 'tool_used', { tool, ...params });
};

// Identify the logged-in user for cross-session continuity.
export const setAnalyticsUser = (uid) => {
  gtag('config', GA_ID, { user_id: uid });
};
